import {Roles} from 'app/Constants';
import IntegrityRoleGrid from 'components/UserRole';
import {Column} from 'devextreme-react/data-grid';
import {i18n2} from 'features/i18n/i18n';
import React from 'react';
import {useIntegrityProfCollaborator} from '../hooks/index';

const ProfCollaboratorGrid = (props: any) => {
  const loadProfCollaborator = useIntegrityProfCollaborator(props.data.key);

  return (
    <IntegrityRoleGrid
      allowEdit={Roles.AdminITPS}
      dataSource={loadProfCollaborator}
      disabledExport={true}
      autoWidth={false}
      id={['revision']}
      height={'30vh'}
      allowIntegrity={false}
      allowActions={false}
    >
      <Column caption={i18n2._('Numero de empleado')} dataField="employee_Nr" />
      <Column caption={i18n2._('#Perfil Spac')} dataField="iD_ProfileSpac" />
      <Column caption={i18n2._('Revision')} dataField="revision" />
      <Column caption={i18n2._('Motivo')} dataField="reason" />
      <Column
        caption={i18n2._('Fecha de actualizacion')}
        dataField="updateDate"
        defaultSortOrder={'desc'}
      />
      <Column caption={i18n2._('Actualizado por')} dataField="updatedBy" />
      <Column caption={i18n2._('Eliminado')} dataField="deleted" width={100} />
    </IntegrityRoleGrid>
  );
};

export default ProfCollaboratorGrid;
